<template>
  <span>
    <v-img
            :src="fileUrl"
            class="grey lighten-2 my-2"
            height="100"
            style="margin: 0 auto;"
            v-if="fileUrl && showImage"
            width="100"/>
    <span v-else>
    </span>
          <v-file-input :label="label" :placeholder="placeholder" :rules="formRules" @change="onFilePicked"
                        outlined ref="inputRef"
                        show-size
                        v-model="innerValue"/>
  </span>
</template>

<script>
  const valid_files = ["png", "jpeg", "jpg", "pdf", "docx"];
  const image_files = ["png", "jpeg", "jpg"];
  export default {

    data: () => ({
      innerValue: null,
      dialog: false,
      fileUrl: null,
      valid_files,
      image_files,
      rules: {
        fileRequired: value => {
          let message = "Required";
          if (value) {
            if (value.name !== undefined)
              message = true;
          }
          return message;
        }
      },
    }),
    props: {
      valid: {
        type: Boolean,
        value: true,
        default: true
      },
      showImage: {
        type: Boolean,
        default: true
      },
      label: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      value: {
        type: null
      },
      required: {
        type: Boolean,
        default: false
      },
      fileLink: {
        type: String,
        default: null
      },
      valid_file_types: {
        type: Array,
        default: () => valid_files
      },
      fileSize: {
        type: Number,
        default: 512
      },
    },
    computed: {
      formRules() {
        let rules = [];
        if (this.required) {
          rules = [this.rules.fileRequired]
        }
        return rules;
      }
    },
    methods: {
      showFilePicker() {
        this.$refs.filePicker.click();
      },
      onFilePicked(e) {
        if (typeof e !== "undefined") {
          let file = e;
          if (file) {
            if (file.name) {
              let extension = file.name.split(".").pop();
              extension = extension.toLowerCase();
              if (!this.valid_file_types.includes(extension)) {
                this.$refs.inputRef.reset();
                this.$store.commit(
                        "Notification/showError",
                        "Please upload a valid file type"
                );
              } else {
                if ((file.size/1000) > this.fileSize) {
                  this.$refs.inputRef.reset();
                  this.$store.commit(
                          "Notification/showError",
                          "File Too Large. Size(in KB) should be less than "+this.fileSize
                  );
                }else {
                  const fileReader = new FileReader();
                  fileReader.readAsDataURL(file);
                  fileReader.addEventListener("load", () => {
                    if (this.showImage && image_files.includes(extension)) {
                      this.fileUrl = fileReader.result;
                    }
                    this.$emit('input', file)
                  });
                }
              }
            }
          }
        } else {
          this.fileUrl = false;
        }
      },
    },
    watch: {
      innerValue(new_value) {
        if (new_value === null) {
          this.fileUrl = null;
        }
        this.$emit('input', new_value)
      },
      value(new_value) {
        if (new_value === null) {
          this.fileUrl = null;
        }
        this.innerValue = new_value
      },
      fileLink(new_value) {
        this.fileUrl = new_value;
      }
    },
    mounted() {
      if (this.fileLink) {
        this.fileUrl = this.fileLink;
      }
    }
  }
  ;
</script>